import { computed } from 'vue'
import { useContextStore, useURLStore } from 'src/store'
import { getReviewsCount } from 'src/components/pages/[town-translit]/diagnostika/analiz/_functions/mapLpuCardProps'
import type { AnalysesPageContext, LpuCardsPageItem } from 'src/components/pages/[town-translit]/diagnostika/analiz/_types'
import type { CommonContextStore } from 'src/types/context'

export default function useAnalysesLpuCardLinks() {
  const { context, urlLang } = useContextStore() as CommonContextStore & {
    context: AnalysesPageContext
  }
  const { reverseFull, reverseFullL10N } = useURLStore()

  const townNamePred = computed(() => (
    context.town?.name_pred
    || context.town?.name
    || ''
  ))

  function getLpuSetHref(lpuSetTranslit: string) {
    return reverseFull({
      name: 'lpuset',
      args: [
        context.town?.translit || '',
        lpuSetTranslit,
      ],
    })
  }

  const lpuSetOrderHref = computed(() => reverseFull({
    name: 'partner_all_analyses',
    args: [context.town?.translit, 'kdl'],
  }))

  const lpuSetCardOptions = computed(() => ({
    townNamePred: townNamePred.value,
    getLpuSetHref,
    lpuSetOrderHref: lpuSetOrderHref.value,
  }))

  function getLpuPageHref(item: LpuCardsPageItem) {
    return reverseFullL10N({
      name: 'lpu_rates',
      args: {
        language: urlLang,
        town_translit: item.town.translit,
        lpu_translit: item.translit,
      },
    })
  }

  function getLpuPriceHref(item: LpuCardsPageItem) {
    return reverseFull({
      name: 'lpu_price',
      args: [
        item.town.translit,
        item.translit,
      ],
    })
  }

  function getLpuReviewsHref(item: LpuCardsPageItem) {
    return reverseFullL10N({
      name: getReviewsCount(item) > 10 ? 'lpu_rates' : 'lpu',
      args: {
        language: urlLang,
        town_translit: item.town.translit,
        lpu_translit: item.translit,
      },
    })
  }

  const lpuCardLinkOptions = {
    getLpuPriceHref,
    getLpuPageHref,
    getLpuReviewsHref,
  }

  return {
    townNamePred,
    lpuSetCardOptions,
    lpuCardLinkOptions,
  }
}
